// extracted by mini-css-extract-plugin
export var deleteModal = "_ji-0";